import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GetLabelFromValue } from './_pipe/label-code.pipe';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { FooterComponent } from './footer/footer.component';
import { AlertComponent, AlertService } from './alert/alert.component';

import { AdministrationComponent } from './administration/administration.component';
import { InvoicingComponent } from './invoicing/invoicing.component';
import { PageNotFoundComponent } from '../app/page-not-found/pagenotfound.component';
import { AdministrationMenuComponent } from './administration/menu/menu.component';
//import { AdministrationCarrierIndexComponent } from './administration/carrier/carrier.component';
import { AdministrationClientIndexComponent } from './administration/client/client.component';
import { RouterModule } from '@angular/router';
import { InvoicingCarrierIndexComponent } from './invoicing/carrier/carrier.component';
import { InvoicingClientIndexComponent } from './invoicing/client/client.component';
import { InvoicingCustomerInvioceIndexComponent } from './invoicing/customer-invoices/customer-invoices.component';
import { InvoicingMenuComponent } from './invoicing/menu/menu.component';

// As we are using Angular 11. We have to use PrimNg version equivallent to 11.
// https://www.primefaces.org/category/primeng/
// https://www.npmjs.com/package/primeng/v/11.4.2

// Angular 12 PrimeNG v12.0.0 depends on Angular 12 and is fully compatible with it. 
// As it is always suggested, use the PrimeNG whose major version matches your Angular version 
// e.g. PrimeNG 12 with Angular 12. Responsive Updates PrimeNG v12.0.0 focuses on 
// improving the responsiveness of components so that they can...

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { ListboxModule } from 'primeng/listbox';

import { CommonService } from './services/common.service';
import { CarriersService } from './services/api/carriers.service';
import { CarrierInvoiceFilesService } from './services/api/carrier-invoice-files.service';
//import { CarrierRateFilesService } from './services/api/carrier-rate-files.service';
import { ClientsService } from './services/api/clients.service';
import { CustomerInvoicesService } from './services/api/customer-invoices.service';
import { HttpTrafficInterceptor } from './interceptors/http-traffic-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginViewComponent } from 'src/Components/login-view/login-view.component';
import { CardModule } from 'primeng/card';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from './services/auth.service';
import { ForgptPasswordComponent } from 'src/Components/forgpt-password/forgpt-password.component';
import { AdministrationCarrierIndexComponent } from './administration/carrier/carrier.component';
import { CreateUserComponent } from 'src/Components/create-user/create-user.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { JwtModule, JwtModuleOptions } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from './Shared Components/snackbar/snackbar.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { AuthGuard } from './Guards/auth-guard.service';
import { PasswordResetComponent } from 'src/Components/password-reset/password-reset.component';
import { MessagePopupComponent } from './Shared Components/message-popup/message-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
//import {MatNativeDateModule} from '@angular/material';
//import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { ProgressBarComponent } from './Shared Components/progress-bar/progress-bar.component';
import { LoaderComponent } from './Shared Components/loader/loader.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { SidenavComponent } from './Shared Components/sidenav/sidenav.component';
import { LoginGuardService } from './Shared Components/login-guard.service';
import { ClientMaterComponent } from './administration/client-mater/client-mater.component';
import { RateFileComponent } from './administration/rate-file/rate-file.component';
import { RatingProfileComponent } from './administration/rating-profile/rating-profile.component';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { LoaderrComponent } from './loader/loaderr/loaderr.component';
//import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
export function tokenGetter() {
  return localStorage.getItem("token");
}
const JWT_Module_Options: JwtModuleOptions = {
  config: {
    tokenGetter: tokenGetter,
    allowedDomains: [environment.token.allowedDomains],
    disallowedRoutes: []
  }
};
@NgModule({
  declarations: [
    AppComponent,
    GetLabelFromValue,
    NavMenuComponent,
    FooterComponent,
    AlertComponent,
    AdministrationComponent,
    InvoicingComponent,
    PageNotFoundComponent,
    AdministrationMenuComponent,
    AdministrationCarrierIndexComponent,
    AdministrationClientIndexComponent,
    InvoicingCarrierIndexComponent,
    InvoicingClientIndexComponent,
    InvoicingCustomerInvioceIndexComponent,
    InvoicingMenuComponent,
    LoginViewComponent,
    ForgptPasswordComponent,
    CreateUserComponent,
    SnackbarComponent,
    PasswordResetComponent,
    MessagePopupComponent,
    ProgressBarComponent,
    LoaderComponent,
    SidenavComponent,
    ClientMaterComponent,
    RateFileComponent,
    RatingProfileComponent,
    LoaderrComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    MatCardModule,
    MatTableModule,
    MatSelectModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatNativeDateModule,
    MatMenuModule,
    MatProgressBarModule,
    // MatMomentDateModule,
    MatProgressSpinnerModule,    // BrowserModule,
    BrowserAnimationsModule,
    MatRadioModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDialogModule,
    TableModule,
    DialogModule,
    ToastModule,
    AutoCompleteModule,
    DropdownModule,
    ListboxModule,
    CalendarModule,
    FileUploadModule,
    MultiSelectModule,
    ProgressBarModule,
    CardModule,
    MatFormFieldModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatSnackBarModule,
    MatExpansionModule,
    JwtModule.forRoot(JWT_Module_Options),

    RouterModule.forRoot([

      { path: '', redirectTo: 'login', pathMatch: 'full' },

      // { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginViewComponent, pathMatch: 'full' },

      { path: 'forgetpassword', component: ForgptPasswordComponent },
      { path: 'resetpassword', component: PasswordResetComponent },
      {
        path: 'administration', component: AdministrationComponent, canActivate: [AuthGuard],
        children: [
          {
            path: 'client-master',
            component: ClientMaterComponent
          },
          {
            path: 'client',
            component: AdministrationClientIndexComponent
          },
          {
            path: 'rate-file',
            component: RateFileComponent
          },
          {
            path: 'rating-profile',
            component: RatingProfileComponent
          },
          {
            path: 'carrier', component: AdministrationCarrierIndexComponent, canActivate: [AuthGuard]
          },

          {
            path: '', redirectTo: 'carrier', pathMatch: 'full'
          },
          {
            path: 'User', component: CreateUserComponent
          }
        ]
      },
      {
        path: 'invoicing', component: InvoicingComponent, canActivate: [AuthGuard],
        children: [
          {
            path: 'client',
            component: InvoicingClientIndexComponent,
          },
          {
            path: 'carrier',
            component: InvoicingCarrierIndexComponent,
          },

          {
            path: 'customer-invoice',
            component: InvoicingCustomerInvioceIndexComponent,
          },
          {
            path: '', redirectTo: 'carrier', pathMatch: 'full'
          }
        ]
      },
      { path: '**', component: PageNotFoundComponent },
    ])
  ],
  providers: [
    LoginGuardService,
    CommonService,
    ClientsService,
    CarriersService,
    // CarrierRateFilesService,
    CarrierInvoiceFilesService,
    CustomerInvoicesService,
    MessageService,
    AlertService,
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpTrafficInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
